import { render, staticRenderFns } from "./form-check.vue?vue&type=template&id=e670a478&scoped=true"
import script from "./form-check.vue?vue&type=script&setup=true&lang=js"
export * from "./form-check.vue?vue&type=script&setup=true&lang=js"
import style0 from "./form-check.vue?vue&type=style&index=0&id=e670a478&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../erp_vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e670a478",
  null
  
)

export default component.exports